"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkuInfoShape = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _reactComponents = require("@cimpress/react-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _reactIntl = require("react-intl");

var _skuSelectorMessages = require("../skuSelectorMessages");

var SkuInfoShape = _propTypes.default.shape({
  description: _propTypes.default.string,
  fulfiller: _propTypes.default.shape({
    fulfillerId: _propTypes.default.string,
    name: _propTypes.default.string
  }),
  name: _propTypes.default.string,
  sceneUrl: _propTypes.default.string,
  sku: _propTypes.default.string.isRequired,
  status: _propTypes.default.string
});

exports.SkuInfoShape = SkuInfoShape;

var SkuCard =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SkuCard, _PureComponent);

  function SkuCard() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SkuCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SkuCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onAction = function () {
      var _this$props = _this.props,
          onAction = _this$props.onAction,
          skuInfo = _this$props.skuInfo,
          disabled = _this$props.disabled;
      return onAction && !disabled && onAction(skuInfo);
    };

    _this.onChangeChecked = function () {
      var _this$props2 = _this.props,
          onChangeChecked = _this$props2.onChangeChecked,
          skuInfo = _this$props2.skuInfo;
      return onChangeChecked && onChangeChecked(skuInfo);
    };

    return _this;
  }

  (0, _createClass2.default)(SkuCard, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          skuInfo = _this$props3.skuInfo,
          className = _this$props3.className,
          draggable = _this$props3.draggable,
          checkable = _this$props3.checkable,
          isChecked = _this$props3.isChecked,
          clickable = _this$props3.clickable,
          isClicked = _this$props3.isClicked,
          hasAction = _this$props3.hasAction,
          actionIcon = _this$props3.actionIcon,
          onAction = _this$props3.onAction,
          disabledTooltipMsg = _this$props3.disabledTooltipMsg,
          formatMessage = _this$props3.intl.formatMessage;

      var innerContent = _react.default.createElement(_react.default.Fragment, null, draggable && _react.default.createElement("div", {
        className: "sku-card__drag"
      }, _react.default.createElement(_reactComponents.Icon, {
        name: "drag_drop_l"
      })), checkable && _react.default.createElement("div", {
        className: "sku-card__pre-action"
      }, _react.default.createElement(_reactComponents.Checkbox, {
        className: "sku-card__pre-action__checkbox",
        checked: isChecked,
        onChange: !disabled ? this.onChangeChecked : null
      })), _react.default.createElement("div", {
        className: "sku-card__info"
      }, _react.default.createElement("div", {
        className: "sku-card__info__top"
      }, _react.default.createElement("span", {
        className: "sku-card__info__top__sku h5"
      }, skuInfo.sku), skuInfo.name && _react.default.createElement("span", {
        className: "sku-card__info__top__name h5"
      }, skuInfo.name)), skuInfo.description && _react.default.createElement("div", {
        className: "sku-card__info__bottom"
      }, skuInfo.description)), hasAction && _react.default.createElement("div", {
        className: "sku-card__post-action"
      }, _react.default.createElement("button", {
        className: "sku-card__post-action__link sku-card__post-action__link".concat(onAction && !disabled ? '--clickable' : '--disabled'),
        onClick: clickable ? null : this.onAction
      }, !disabled ? _react.default.createElement(_reactComponents.Icon, {
        name: actionIcon
      }) : _react.default.createElement(_reactComponents.Icon, {
        name: actionIcon,
        color: _reactComponents.colors.slate
      }))));

      return disabled ? _react.default.createElement(_reactComponents.Tooltip, {
        containerClassName: (0, _emotion.cx)('sku-card', className, {
          disabled: disabled
        }),
        contents: disabledTooltipMsg || formatMessage(_skuSelectorMessages.skuCardMessages.disabledTooltip)
      }, innerContent) : _react.default.createElement("div", {
        className: (0, _emotion.cx)('sku-card', className, {
          'sku-card--active': isClicked,
          'sku-card--clickable': clickable
        }),
        onClick: clickable ? this.onAction : null
      }, innerContent);
    }
  }]);
  return SkuCard;
}(_react.PureComponent);

SkuCard.defaultProps = {
  draggable: false,
  checkable: false,
  hasAction: false
};

var _default = (0, _reactIntl.injectIntl)(SkuCard);

exports.default = _default;